<template>
  <div id="helpers-formatar-moeda">
    <span v-if="COMPUTED_TIPO_FORMATADO !== 'ST'">{{ COMPUTED_TIPO_FORMATADO }}</span>

    <v-tooltip bottom v-else>
      <template v-slot:activator="{ on, attrs }">
        <span class="cursor-help" v-bind="attrs" v-on="on">{{ COMPUTED_TIPO_FORMATADO }}</span>
      </template>

      <span v-if="COMPUTED_TIPO_FORMATADO === 'ST'">Sem tabela</span>
    </v-tooltip>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { formatarMoeda } from '@/helpers';

const props = defineProps({ tipo: String });

const COMPUTED_TIPO_FORMATADO = computed(() => formatarMoeda(props.tipo));
</script>

<style scoped>
#helpers-formatar-moeda {
  display: inline !important;
}
</style>

